<template>
	<el-container>
		<el-header class="greenmenu">
			<span @click="$router.back(-1)" class="backstr">
				<返回</span> 
				<span class="header_h2">支付
			</span>
		</el-header>
		<div class="menulist">
			<ul>
				<li>
					<ul class="ulleft">
						<li>
							<span class="spanlabel">总计：</span>
							<span class="spantxt">{{paySum}}</span>
						</li>
						<li v-if="grpSum>0">
							<span class="spanlabel">分组金额：</span>
							<span class="spantxt">+ ¥{{grpSum}}</span>
						</li>
						<li v-if="grpaddClinet>0">
							<span class="spanlabel">加项包单位付：</span>
							<span class="spantxt">- ¥{{grpaddClinet}}</span>
						</li>
						<li v-if="grpaddCus>0">
							<span class="spanlabel">加项包自费：</span>
							<span class="spantxt">+ ¥{{grpaddCus}}</span>
						</li>
						<li v-if="cuspayed>0">
							<span class="spanlabel">已付：</span>
							<span class="spantxt">- ¥{{cuspayed}}</span>
						</li>
						<li>
							<span class="spanlabel">待付款：</span>
							<span class="spantxt"> ¥{{cuspaySum}}</span>
						</li>
					</ul>
				</li>
				<li>
					<mainpay v-if="cuspaySum>0" v-on:payok="toSelBookBranch" :incusent='cusent' :inAmount='cuspaySum'></mainpay>
					<!-- <el-button v-if="cuspaySum>0" @click="toPay()">支付</el-button> -->
					<el-button v-if="cuspaySum<=0" @click="toSelBookBranch()">现在去预约</el-button>
				</li>
			</ul>
			<ul>
				<li>加项包项目明细</li>
				<li>
					<div class="divframe">
						<el-table size="mini" border tooltip-effect="dark" :data="groupadditems">
							<el-table-column prop="SaleModuleName" label="项目名称">
							</el-table-column>
							<el-table-column prop="CurPrice" label="价格">
							</el-table-column>
						</el-table>
					</div>
				</li>
			</ul>
			<ul>
				<li>自费分组项目明细</li>
				<li>

					<div class="divframe">
						<el-table size="mini" border tooltip-effect="dark" :data="groupitems">
							<el-table-column prop="SaleModuleName" label="项目名称">
							</el-table-column>
							<el-table-column prop="CurPrice" label="价格">
							</el-table-column>
						</el-table>
					</div>

				</li>
			</ul>
			
		</div>


	</el-container>
</template>

<script>
	import ordergroup from '../../apifunction/OrderGroup.js'
	import grpadd from '../../apifunction/GroupAddItem.js'
	import ordercus from '../../apifunction/OrderCus.js'
	import mainpay from '../OnlinePay/ordercuspay.vue'
	export default {
		created() {
			this.cusid=this.$route.query.ent;
			// this.cusent = JSON.parse(;
			this.Init();
		},
		components:{
		mainpay	
		},
		data() {
			return {
				cusid:'',
				cusent: null,
				ordergroupent: null,
				groupaddent: null,
				cusitems: [],
				groupitems: [],
				groupadditems: [],
				paySum: 0, //总计
				grpSum: 0, //分组金额
				grpaddClinet: 0, //加项包单位付部分
				grpaddCus: 0, //加项包个人部分
				cuspaySum: 0, //总计自费
				cuspayed: 0 //已支付金额
			}
		},
		methods: {
			// toPay:function(){
			// 	ordercus.ProOrderCusPay(this.cusent.corpid,this.cusent.id,this.cuspaySum)
			// 	.then(res1 => {
			// 		let entgrp = JSON.parse(JSON.stringify(res1.data))
			// 		if (entgrp.Flag == 'success') {
			// 			this.$message.info('支付成功！');
			// 		}
			// 		else
			// 		this.$message.info('支付失败，请刷新重试！');
			// 	});
			// },
			Init(){
				ordercus.GetOrderCusByCusID(this.cusid)
				.then(res => {
					let entga = JSON.parse(JSON.stringify(res.data))
					if (entga.Flag == 'success') {
						if (entga.Data != 'null') {
							this.cusent = JSON.parse(entga.Data)[0];
							this.InitCusItem();
						}
						}
						})
			},
			toSelBookBranch: function() {
				var data = {
					path: '/SelBookBranch',
					query: {
						ent: JSON.stringify(this.cusent)
					}
				};
				this.$router.push(data)

			},
			InitCusItem() {
				ordercus.GetCusItemsByCusID(this.cusent.id)
					.then(res => {
						let entga = JSON.parse(JSON.stringify(res.data))
						if (entga.Flag == 'success') {
							if (entga.Data != 'null') {
								this.cusitems = JSON.parse(entga.Data);
								let sum = 0;
								let grpSumtemp = 0;
								let grpaddSumtemp = 0;
								let cuspayedtemp = 0;
								for (let i = 0; i < this.cusitems.length; i++) {
									if (this.cusitems[i].GroupAddID == '') {
										this.groupitems.push(this.cusitems[i]);
										grpSumtemp += this.cusitems[i].CurPrice;
									} else {
										this.groupadditems.push(this.cusitems[i]);
										grpaddSumtemp += this.cusitems[i].CurPrice;
									}
									if (this.cusitems[i].PayState == '1')
										cuspayedtemp += this.cusitems[i].CurPrice;
									sum += this.cusitems[i].CurPrice;

								}
								this.paySum = parseFloat(sum).toFixed(2);
								this.grpSum = parseFloat(grpSumtemp).toFixed(2);
								this.cuspayed = parseFloat(cuspayedtemp).toFixed(2);
								if (this.groupitems.length > 0) {
									ordergroup.GetOrderGroupByGroupID(this.cusent.orderid, this.cusent.groupid)
										.then(res1 => {
											let entgrp = JSON.parse(JSON.stringify(res1.data))
											if (entgrp.Flag == 'success') {
												if (entgrp.Data != 'null') {
													this.ordergroupent = JSON.parse(entgrp.Data)[0];
													//this.grpSum=this.ordergroupent.GroupPrice;
												}
											}
										});
								}
								if (this.groupadditems.length > 0) {
									grpadd.GetGroupAddByID(this.groupadditems[0].GroupAddID)
										.then(res1 => {
											let entgrp = JSON.parse(JSON.stringify(res1.data))
											if (entgrp.Flag == 'success') {
												if (entgrp.Data != 'null') {
													this.groupaddent = JSON.parse(entgrp.Data)[0];
													if (this.groupaddent.PayType == '2')
														this.grpaddClinet = this.groupaddent.ClientPay;
													this.grpaddCus =parseFloat(grpaddSumtemp - this.grpaddClinet).toFixed(2) ;
													this.cuspaySum =parseFloat( this.paySum - this.grpaddClinet - this.cuspayed).toFixed(2) ;
												}
											}
										});
								}
							}
						}
					});
			}
		}
	}
</script>

<style>
</style>
